import {
    initializeFaro,
    getWebInstrumentations,
    type Faro,
    type TransportItem,
} from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import appConfig from 'app-config';
import { redact } from 'flow/utils/browser-utils';

const E164_PATTERN = /\+\d{7,15}/g;

const scrubItem = (item: TransportItem): TransportItem => {
    const payload = { ...item.payload } as Record<string, unknown>;

    if (typeof payload['message'] === 'string') {
        payload['message'] = redact(payload['message']);
    }
    if (payload['context'] && typeof payload['context'] === 'object') {
        payload['context'] = redact(payload['context']);
    }
    if (typeof payload['value'] === 'string') {
        payload['value'] = redact(payload['value']);
    }
    if (payload['resourceSpans']) {
        const raw = JSON.stringify(payload['resourceSpans']).replace(
            E164_PATTERN,
            '[number]',
        );
        payload['resourceSpans'] = JSON.parse(redact(raw));
    }

    return { ...item, payload };
};

// Prod configs always provide a collector URL (default telemetry.telavox.com);
// in dev it is empty unless FARO_COLLECTOR_URL is set, which disables Faro.
const collectorUrl = appConfig.faroCollectorUrl || null;

let _faro: Faro | null = null;

export const getFaro = (): Faro | null => _faro;

export const initFaro = (): void => {
    if (_faro || !collectorUrl) return;

    _faro = initializeFaro({
        url: collectorUrl,
        apiKey: appConfig.telemetryApiKey,
        app: {
            name: appConfig.beta ? 'webclient-beta' : 'webclient',
            version: appConfig.version,
            environment: appConfig.environment,
        },
        beforeSend: scrubItem,
        instrumentations: [
            ...getWebInstrumentations({
                captureConsole: true,
            }),
            new TracingInstrumentation(),
        ],
    });
};
